import React from "react";

import { HubDialogWrapper } from "../HubDialogWrapper";
import SerializationContent from "./SerializationContent";

export const WorkOrderSerializationDialog = () => {
  return (
    <HubDialogWrapper maxWidth="md" name="work-order-serialization">
      <SerializationContent />
    </HubDialogWrapper>
  );
};

export default WorkOrderSerializationDialog;
